import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { DgMktCampaignExecutionContainerModel } from '../../../../../../models';
import { ApiVisa, Pagination } from '../../shared';

@Injectable({
  providedIn: 'root',
})
export class DgMktCampaignExecutionService extends BaseApiTemplateService<DgMktCampaignExecutionContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'campaign-executions/backoffice-ep';

  constructor(http: HttpClient) {
    super();

    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'campaign-executions/backoffice-ep';

    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'campaign-executions/backoffice-ep';

    this.httpClient = http;
  }

  async exportCampaignExecutionReportCsvAsBlob(
    pagination: Pagination,
    apiVisa: ApiVisa
  ) {
    let { apiUrl } = this;

    if (this.endpoint_path && apiVisa.api_domain_url) {
      apiUrl =
        apiVisa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.DGMKT_MODULE_PREFIX;
    }

    const CSV_URL =
      apiUrl +
      'campaign-executions/reports/export/csv/backoffice-ep?' +
      pagination.getQueryKeyValues();

    const headers = new HttpHeaders({
      authorization: apiVisa.jwt_secret,
      tenantCode: apiVisa.tenantCode,
    });

    const fileBlob = await this.httpClient
      .get(CSV_URL, { headers, responseType: 'blob' })
      .toPromise();

    return fileBlob;
  }
}
